import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./ReviewCarousel.css"; // Import custom CSS

import KateřinaK from "./assets/KateřinaK.jpeg";
import DanielP from "./assets/DanielP.jpeg";
import PatrikK from "./assets/PatrikK.jpeg";
import JanD from "./assets/JanD.jpeg";
import SlavekN from "./assets/SlavekN.jpeg";
import MartinV from "./assets/MartinV.jpeg";

const reviews = [
    {
        name: "Kateřina K.",
        flag: "🇨🇿",
        text: "Buying a car on Carvago was simply a pleasure. Everything went smoothly, I always knew what stage the car was in and what would happen next. Excellent communication with everyone at Carvago, they are just great. The car was delivered in great condition, exactly as described by the mechanic in the car audit. The car is beautiful and thanks a lot to all of you at Carvago My dream came true and it was the best...birthday present!!!! Regards, your fan 😊",
        image: KateřinaK,
        rating: 5,
    },
    {
        name: "Daniel P.",
        flag: "🇨🇿",
        text: "I would like to thank Carvag for importing my new car, everything was done in 1 time, including services, handover and after-sales service😊 I definitely recommend!🙌🏼…",
        image: DanielP,
        car: "Volkswagen Arteon",
        rating: 5,
    },
    {
        name: "Patrik K.",
        flag: "🇨🇿",
        text: "After much hesitation and selection, I finally chose the Seat Ateca, which met all the requirements and fit nicely into my budget. It drives very well, I have a great view from it, I put everything I need in it and the operating costs are also ok so far. The car was literally brought to me in a gift box and the driver who handed it over to me was very nice and helpful, he showed me everything and explained it. My big thanks goes to Carvago, because their services are 100% customer service.",
        image: PatrikK,
        rating: 5,
    },
    {
        name: "Patrik K.",
        flag: "🇨🇿",
        text: "Carvago arranged for me to buy a Kia Sportage, which after a few tens of kilometers had a problem with the exhaust system, which the company's acceptance technician had no chance to discover on the spot. Carvago arranged a service at an authorized service center and the relatively expensive replacement of the GPF filter and sensor was covered by the company's warranty. Even these complications and their quick solution showed the solidity and professionalism of this company.",
        image: JanD,
        rating: 5,
    },
    {
        name: "Patrik K.",
        flag: "🇨🇿",
        text: "Buying a car on Carvago is simply a treat. At the beginning, of course, I had certain concerns, but I can say with a calm heart that these fears were certainly not justified. Lots of cars to choose from and when I made my choice, the communication with Carvago was absolutely perfect. I always knew what was happening and what was going to happen next. I never registered that the operators on Carvag were nervous and I never they didn't say no and always tried to answer my questions. ",
        image: SlavekN,
        rating: 5,
    },
    {
        name: "Patrik K.",
        flag: "🇨🇿",
        text: "I knew what I wanted and I knew I wanted it from the get-go, because the condition of cars in our bazaars is poor in my experience. For the same or often even better money, you can buy a car abroad in top condition, with a high probability of having it serviced at an authorized service center, of acceptable mileage and age. Carvago brought my chosen car from Germany. I'm glad that I didn't have to deal with the hassle of importing a car.",
        image: MartinV,
        rating: 5,
    },
    // Add more reviews here
];

const ReviewCarousel = () => {
    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        arrows: true,
        responsive: [
            {
                breakpoint: 1024, // Adjust for tablet devices
                settings: { slidesToShow: 2, slidesToScroll: 1 },
            },
            {
                breakpoint: 600, // Adjust for mobile devices
                settings: { slidesToShow: 1, slidesToScroll: 1 },
            },
        ],
    };

    return (
        <div className="carousel-section">
            <div className="carousel-container">
                <h2 className="carousel-heading">Customer Reviews</h2>
                <Slider {...settings}>
                    {reviews.map((review, index) => (
                        <div key={index} className="review-card">
                            <img
                                src={review.image}
                                alt={`${review.name}'s car`}
                                className="review-image"
                            />
                            <div className="review-content">
                                <h3>
                                    {review.name} {review.flag}
                                </h3>
                                <p>{review.text}</p>
                                {review.car && (
                                    <p>
                                        <strong>Car:</strong> {review.car}
                                    </p>
                                )}
                                <div className="review-rating">
                                    {"⭐".repeat(review.rating)}
                                </div>
                            </div>
                        </div>
                    ))}
                </Slider>
            </div>
        </div>
    );
};

export default ReviewCarousel;